// ---- js/daily-board.js
/* The Daily Run page: today's top brains, from the same API the game uses. */
(function () {
  'use strict';
  const box = document.getElementById('daily-board');
  if (!box || !window.fetch) return;
  const esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  fetch('/api/daily', { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (b) {
    if (!b || !Array.isArray(b.top)) throw new Error('no board');
    box.innerHTML = '<h2>Daily #' + (b.day | 0) + ': top brains</h2>' + (b.top.length
      ? '<ol>' + b.top.map(function (r, i) { return '<li><span class="rk">' + (i + 1) + '</span><span class="nm">@' + esc(r.name) + '</span><span class="sc">' + (r.score | 0) + '</span></li>'; }).join('') + '</ol>' +
        '<p class="muted">' + (b.players | 0) + (b.players === 1 ? ' player' : ' players') + ' so far today. Every score was replayed by our server.</p>'
      : '<p class="muted">Nobody has played today\'s Daily yet. Be the first on the board.</p>');
  }).catch(function () {
    box.innerHTML = '<h2>Today\'s top brains</h2><p class="muted">The leaderboard is taking a nap. Play the Daily and check back soon.</p>';
  });
})();
